<div
  class="
    px-3 py-2
    bg-primary
    border-bottom border-light border-opacity-25
    d-flex justify-content-between align-items-center
    rounded-top-4
  "
>
  <div class="d-flex align-items-center gap-3 min-w-0">
    <div class="bg-white bg-opacity-10 p-2 rounded-4 fs-5 text-white">
      <i class="bi bi-robot"></i>
    </div>

    <div class="min-w-0">
      <h6 class="text-white fw-semibold mb-0 d-flex align-items-center gap-2">
        <span>DBE Assist</span>
        <span class="chatbot-version-badge">Limited Version</span>
      </h6>
      <small class="text-white-50 fw-semibold d-block text-truncate">
        {{ title }}
      </small>
    </div>
  </div>

  <div class="d-flex align-items-center gap-1">
    <button
      class="btn btn-sm btn-outline-light border-0 rounded-circle d-inline-flex align-items-center justify-content-center p-0 chatbot-icon-btn"
      @click="$emit('toggle-history')"
      :aria-label="is_history_open ? 'Hide conversation history' : 'Show conversation history'"
      :title="is_history_open ? 'Hide history' : 'Show history'"
    >
      <i :class="is_history_open ? 'bi bi-layout-sidebar-inset' : 'bi bi-layout-sidebar'"></i>
    </button>

    <button
      class="btn btn-sm btn-outline-light border-0 rounded-circle d-inline-flex align-items-center justify-content-center p-0 chatbot-icon-btn"
      @click="$emit('new-conversation')"
      aria-label="Start new conversation"
      title="New conversation"
    >
      <i class="bi bi-plus-lg"></i>
    </button>

    <button
      class="btn btn-sm btn-outline-light border-0 rounded-circle d-inline-flex align-items-center justify-content-center p-0 chatbot-icon-btn"
      @click="$emit('toggle-fullscreen')"
      :aria-label="is_fullscreen ? 'Exit fullscreen' : 'Open fullscreen'"
      :title="is_fullscreen ? 'Exit fullscreen' : 'Fullscreen'"
    >
      <i :class="is_fullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-arrows-fullscreen'"></i>
    </button>

    <button
      class="btn btn-sm btn-outline-light border-0 rounded-circle d-inline-flex align-items-center justify-content-center p-0 chatbot-icon-btn"
      @click="$emit('close')"
      aria-label="Close assistant"
      title="Close"
    >
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
